import { FormGroup } from "@angular/forms";
import { FormlyView } from "../FormlyView";
import { FieldDefinition } from "../../../../sections/medicinalProduct/message/fieldDefinition";
import { Injector } from "@angular/core";

export class SubstanceTranslationEntity extends FormlyView {

    constructor(injector: Injector, model: any) {
        const fieldDefinition: FieldDefinition = new FieldDefinition(injector);
        super( new FormGroup({}), 
            [...fieldDefinition.substanceTranslationFields], model);
        // model                
    }

}